import React from "react"
import Radium from "radium"

const _blueButton = (disabled) => ({
    cursor: 'pointer',
    display: 'inline-block',
    minHeight: '1em',
    outline: 0,
    border: '1px solid #a9000a',
    verticalAlign: 'baseline',
    backgroundColor: disabled ? '#D3D3D3' : '#a9000a',
    color: disabled ? '#a2a2a2' : '#fff',
    fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
    padding: '.78571429em 1.5em .78571429em',
    textTransform: 'none',
    textShadow: 'none',
    fontWeight: 700,
    lineHeight: '1em',
    fontStyle: 'normal',
    textAlign: 'center',
    textDecoration: 'none',
    borderRadius: '.28571429rem',
    boxShadow: '0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
    transition: 'opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease',
    ':hover':{
        backgroundColor: '#9f0009',
        boxShadow: '0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
        color: '#f5f5f5'
    },
    ':active': {
        backgroundColor: '#91000a',
        color: '#e6e6e6'
    }

})

const SecondaryRedButton = ({text, type, style, disabled, onClick, children }) => {
    return (
        <button style={{..._blueButton(disabled), ...style}} type={type} disabled={disabled} onClick={(e) => {if(e !== undefined) e.preventDefault();onClick()}}>{text} {children}</button>
    )
}

export default Radium(SecondaryRedButton)